module.exports = __webpack_public_path__ + "img/76280.ca282214.svg";